import { render, staticRenderFns } from "./promiseLetter.vue?vue&type=template&id=384e4fe4&scoped=true"
import script from "./promiseLetter.vue?vue&type=script&lang=js"
export * from "./promiseLetter.vue?vue&type=script&lang=js"
import style0 from "./promiseLetter.vue?vue&type=style&index=0&id=384e4fe4&prod&lang=less&scoped=true"
import style1 from "./promiseLetter.vue?vue&type=style&index=1&id=384e4fe4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384e4fe4",
  null
  
)

export default component.exports